export const buildPresentationMakerCandidateParam = candidateData => {
  if (!candidateData || !candidateData?.id) return null;

  const { id, personalInformation, title, specialty, subspecialty } = candidateData || {};
  const { address } = personalInformation || {};

  return {
    candidate: {
      id,
      title,
      industry: specialty?.industry?.title,
      specialty: specialty?.title,
      subspecialty: subspecialty?.title,
      state: address?.city?.state?.title,
      city: address?.city?.title,
      postalCode: address?.zip
    }
  };
};
